export default __webpack_public_path__ + "static/spot-blood-65016dd4f650503b37e4ef5f33dfef52.jpg";